import clsx from 'clsx';
import { Box } from '@alf/uikit';
import ProviderImage from '../../../../../common/ProviderImage';
import ProviderTag from '../../../../../common/ProviderTag';
import { FILTER_TYPES } from '../../../../../constants';

import styles from './index.module.css';

export const SingleProviderItem = ({
  onFilterItemClick,
  providerData,
  isActive,
  isDisabled,
  showProvidersTags = false,
  tagsConfig
}) => {
  const { providerLogo, providerColoredLogo, label, id, tag } = providerData;

  return (
    <Box
      onClick={() => onFilterItemClick(id, FILTER_TYPES.PROVIDERS)}
      justify="center"
      align="center"
      className={clsx([
        styles.providerContainer,
        isActive && styles.selectedProvider,
        isDisabled && styles.providerContainerDisabled
      ])}
    >
      {showProvidersTags && <ProviderTag tag={tag} tagsConfig={tagsConfig} />}
      <ProviderImage
        providerName={label}
        providerLogo={providerLogo}
        providerColoredLogo={providerColoredLogo}
        classNames={{ providerLogoClassName: styles.providerImage }}
      />
    </Box>
  );
};
